/**
 * The one violation to show when there is room for one chip: the first coded type that is not the
 * OTHER placeholder, else the first of the "other" list (where the real type lives when the coded
 * list is just OTHER), else OTHER itself. Also returns how many more there are.
 */
export function headlineViolation(violationTypes?: string[] | null, otherViolationTypes?: string[] | null): { type: string | null; more: number } {
  const coded = (violationTypes || []).filter((t) => t !== 'OTHER');
  const all = [...coded, ...(otherViolationTypes || [])];
  if (all.length === 0) return { type: (violationTypes || []).includes('OTHER') ? 'OTHER' : null, more: 0 };
  return { type: all[0], more: all.length - 1 };
}
